import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Route, Routes, Navigate, useNavigate } from 'react-router-dom';
import axios from 'axios';

// Components
import LoginPage from './components/LoginPage';
import MySunPage from './components/MySunPage';
import UserList from './components/UserList';
import OtherSun from './components/OtherSun';
import UserSunPage from './components/UserSunPage';
import UserAccountInfo from './components/UserAccountInfo';
import SupportersList from './components/SupportersList';
import NavigationBar from './components/NavigationBar'; 
import Modal from './components/Modal'; 
import ProfileSetup from './components/ProfileSetup';  // +++ 추가됨 +++

import KakaoShareButton from './components/KakaoShareButton';
import WebShareButton from './components/WebShareButton';
import Share from './components/Share';


import { GoogleOAuthProvider } from '@react-oauth/google';

const App = () => {
    const [token, setToken] = useState(() => localStorage.getItem('token') || null);
    // const [currentId, setCurrentId] = useState(localStorage.getItem('username') || '');
    const [clientUsername, setClientUsername] = useState(localStorage.getItem('username') || '');
    const [clientUuid, setClientUuid] = useState(localStorage.getItem('uuid') || '');

    const [showAccountInfo, setShowAccountInfo] = useState(false);
    const [showSupporters, setShowSupporters] = useState(false);
    const [showShare, setShowShare] = useState(false);
    const [showOtherSun, setShowOtherSun] = useState(false);
    const [isLoading, setIsLoading] = useState(true);
    
    const handleOpenAccountInfo = () => setShowAccountInfo(true);
    const handleCloseAccountInfo = () => setShowAccountInfo(false);

    const handleOpenSupporters = () => setShowSupporters(true);
    const handleCloseSupporters = () => setShowSupporters(false);

    const handleOpendShare = () => setShowShare(true);
    const handleClosedShare = () => setShowShare(false);
    

    const handleOpenOtherSun = () => setShowOtherSun(true);
    const handleClosedOtherSun = () => setShowOtherSun(false);
    


    // const handleOpenTraditionGame = () => setShowTraditionGame(true);

    // const navigate = useNavigate();

    // useEffect(() => {
    //     const validateToken = async () => {
    //         if (token) {
    //             try {
    //                 const response = await axios.get('/validateToken', {
    //                     headers: { Authorization: `Bearer ${token}` },
    //                 });
    //                 if (!response.data.valid) {
    //                     setToken(null);
    //                     alert('Session expired. Please log in again.');
    //                 }
    //             } catch (error) {
    //                 setToken(null);
    //                 alert('Error validating token. Please log in again.');
    //             }
    //         }
    //     };
    //     validateToken();
    // }, [token]);

        // 앱 로드 시 토큰 검증 및 인증 상태 복원
        // useEffect(() => {
        //     const validateToken = async () => {
        //         if (token) {
        //             try {
        //                 const response = await axios.get('/validateToken', {
        //                     headers: { Authorization: `Bearer ${token}` },
        //                 });
        //                 if (!response.data.valid) {
        //                     handleLogout(); // 유효하지 않은 경우 로그아웃
        //                 }
        //             } catch (error) {
        //                 handleLogout(); // 에러 발생 시 로그아웃
        //             }
        //         }
        //     };
        //     validateToken();
        // }, [token]);

    // 2. 토큰 검증 및 초기 상태 복원
    // useEffect(() => {
    //     const validateToken = async () => {
    //         if (token) {
    //             try {
    //                 const response = await axios.get('/validateToken', {
    //                     headers: { Authorization: `Bearer ${token}` },
    //                 });
    //                 if (!response.data.valid) {
    //                     handleLogout(); // 토큰이 유효하지 않으면 로그아웃
    //                 } else {
    //                     setIsLoading(false); // 유효하면 로딩 완료
    //                 }
    //             } catch (error) {
    //                 console.error('Error validating token:', error);
    //                 handleLogout(); // 에러 발생 시 로그아웃
    //             }
    //         } else {
    //             setIsLoading(false); // 토큰이 없으면 바로 로딩 완료
    //         }
    //     };

    //     validateToken();
    // }, [token]);

    // Kakao SDK init 예시
    if (window.Kakao && !window.Kakao.isInitialized()) {
        window.Kakao.init('faac188167b161c26238eadc69d163ca');
    }

    // const navigate = useNavigate(); // 라우팅을 위한 훅


    // 2. 로그인 핸들러: 토큰과 username을 상태 및 localStorage에 저장
    const handleLogin = (newToken, uuid, username) => {
        setToken(newToken);
        setClientUuid(uuid);
        setClientUsername(username);
        localStorage.setItem('token', newToken);
        localStorage.setItem('uuid', uuid);
        localStorage.setItem('username', username);
    };

    // 3. 로그아웃 핸들러: 상태와 localStorage를 초기화
    const handleLogout = () => {
        setToken(null);
        setClientUuid('');
        localStorage.removeItem('token');
        localStorage.removeItem('uuid');
        localStorage.removeItem('username');
        // navigate('/'); // 로그아웃 후 로그인 페이지로 이동
    };

    // 2. 로그인 핸들러: 토큰과 username을 상태 및 localStorage에 저장
    const handleClientUsername = (username) => {
        setClientUsername(username);
        localStorage.setItem('username', username);
    };

    // 4. 앱 로드 시 토큰 검증 및 상태 복원
    useEffect(() => {


        const validateToken = async () => {
            if (token) {
                try {
                    const response = await axios.get('/auth/tokens', {
                        headers: { Authorization: `Bearer ${token}` },
                    });
                    if (!response.data.valid) {
                        handleLogout(); // 토큰이 유효하지 않으면 로그아웃
                    }
                } catch (error) {
                    alert('로그인하여 주세요', error);
                    handleLogout(); // 에러 발생 시 로그아웃
                }
            }
            setIsLoading(false); // 검증 완료 후 로딩 상태 해제
        };
        setIsLoading(false);
        validateToken();
    }, [token]);

        // 6. 로딩 중일 때 로딩 화면 표시
        if (isLoading) return <p>Loading....</p>;
    
    return (
        <GoogleOAuthProvider clientId="1084447799900-d7l0lal716vj64bj7u7kukm46uhkjmdk.apps.googleusercontent.com">
            <Router>
                <Routes>
                    
                    {/* Login Page */}
                    <Route
                        path="/"
                        element={
                            !token ? (
                                <LoginPage handleLogin={handleLogin} />
                
                                // <LoginPage
                                //     setToken={setToken}
                                //     setUsername={setCurrentUsername}
                                // />
                            ) : (
                                <Navigate to="/mySun" />
                            )
                            
                        }
                    />

                    {/* Profile Setup Page */}
                    <Route
                        path="/profile"
                        element={
                            token ? (
                                <ProfileSetup
                                    token={token}
                                    setClientUsername={handleClientUsername}
                                    clientUuid={clientUuid}
                                    onProfileUpdated={() => {
                                    // 프로필 업데이트 후 mySun 페이지로 이동
                                    window.location.href = '/mySun';
                                    }}
                                />
                            ) : (
                                <Navigate to="/" />
                            )
                        }
                    />


                    {/* Main Page (mySun) */}
                    <Route
                        path="/mySun"
                        element={
                            token ? (
                                <div>
                                    <NavigationBar
                                        token={token}
                                        onOpenAccountInfo={handleOpenAccountInfo}
                                        onShowSupporters={handleOpenSupporters}
                                        onShowShare={handleOpendShare}
                                        onShowOtherSun={handleOpenOtherSun}
                                        onLogout={handleLogout}
                                        isLoggedIn={!!token}
                                    />
                                    <MySunPage
                                        token={token}
                                        username={clientUsername}
                                        clientUuid={clientUuid}
                                        onOpenAccountInfo={handleOpenAccountInfo}
                                    />

                                    {/* UserAccountInfo Modal */}
                                    <Modal isOpen={showAccountInfo} onClose={handleCloseAccountInfo}>
                                        <UserAccountInfo
                                            token={token}
                                            clientUuid={clientUuid}
                                            onClose={handleCloseAccountInfo}
                                        />
                                    </Modal>

                                    {/* SupportersList Modal */}
                                    <Modal isOpen={showSupporters} onClose={handleCloseSupporters}>
                                        <SupportersList
                                            token={token}
                                            clientUuid={clientUuid}
                                            onClose={handleCloseSupporters}
                                        />
                                    </Modal>

                                    {/* UserList Modal */}
                                    <Modal isOpen={showOtherSun} onClose={handleClosedOtherSun}>
                                    <OtherSun 
                                        token={token}
                                        onClose={handleClosedOtherSun}
                                        />
                                    </Modal>

                                    {/* SupportersList Modal */}
                                    <Modal isOpen={showShare} onClose={handleClosedShare}>
                                        <Share
                                            token={token}
                                            clientUuid={clientUuid}
                                            clientUsername={clientUsername}
                                        />
                                    </Modal>



                                    {/* TraditionGame Modal */}
                                    {/* <Modal
                                        isOpen={showTraditionGame}
                                        onClose={handleCloseTraditionGame}
                                    >
                                        <TraditionGame
                                            token={token}
                                            username={currentUsername}
                                            onSuccess={(updatedNewYearSun) => {
                                                console.log('TraditionGame success:', updatedNewYearSun);
                                                // 원하는 로직...
                                                handleCloseTraditionGame();
                                            }}
                                            onClose={handleCloseTraditionGame}
                                        />
                                    </Modal> */}

                                    {/* TraditionGame 실행 버튼 */}
                                    {/* <div style={{ textAlign: 'center', marginTop: '20px' }}>
                                        <button onClick={handleOpenTraditionGame}>윷놀이 실행</button>
                                    </div> */}
                                </div>
                            ) : (
                                <Navigate to="/" />
                            )
                        }
                    />

                    {/* User's Sun Page */}
                    {/* <Route
                        path="/userSun/:uuid"
                        element={
                            token ? (
                                <UserSunPage
                                    token={token}
                                    currentUsername={currentUsername}
                                />
                            ) : (
                                <Navigate to="/" />
                            )
                        }
                    /> */}
                    <Route
                        path="/userSun/:uuid"
                        element={(
                            <div>
                                <NavigationBar
                                        token={token}
                                        onOpenAccountInfo={handleOpenAccountInfo}
                                        onShowSupporters={handleOpenSupporters}
                                        onShowShare={handleOpendShare}
                                        onShowOtherSun={handleOpenOtherSun}                                        
                                        onLogout={handleLogout}
                                        isLoggedIn={!!token}
                                        
                                    />
                                <UserSunPage
                                        token={token}
                                        clientUuid={clientUuid}
                                        onOpenAccountInfo={handleOpenAccountInfo}
                                    />

                                    {/* UserAccountInfo Modal */}
                                    <Modal isOpen={showAccountInfo} onClose={handleCloseAccountInfo}>
                                        <UserAccountInfo
                                            token={token}
                                            clientUuid={clientUuid}
                                            onClose={handleCloseAccountInfo}
                                        />
                                    </Modal>

                                    {/* SupportersList Modal */}
                                    <Modal isOpen={showSupporters} onClose={handleCloseSupporters}>
                                        <SupportersList
                                            token={token}
                                            clientUuid={clientUuid}
                                            onClose={handleCloseSupporters}
                                        />
                                    </Modal>

                                    {/* UserList Modal */}
                                    <Modal isOpen={showOtherSun} onClose={handleClosedOtherSun}>
                                        <OtherSun 
                                        token={token}
                                        onClose={handleClosedOtherSun}
                                        />
                                        
                                    </Modal>

                                    {/* SupportersList Modal */}
                                    <Modal isOpen={showShare} onClose={handleClosedShare}>
                                        <Share
                                            token={token}
                                            clientUuid={clientUuid} 
                                            clientUsername={clientUsername}     
                                                                              
                                        />
                                    </Modal>
                            </div>
                                )
                        }
                    />

                    {/* Fallback for undefined routes */}
                    <Route path="*" element={<p>404 Not Found</p>} />
                </Routes>
            </Router>
        </GoogleOAuthProvider>
    );
};

export default App;
